import React from 'react';
import { useInstantSearch } from 'react-instantsearch';

import SearchErrorMessage from '../ErrorMessage';

interface SearchErrorStateProps {
  children?: React.ReactNode;
}

/**
 * Renders an error message with a retry button instead of `children` when the
 * last search request failed. Wrap result lists in this, so a failed search
 * doesn't show an empty list or the results of the previous search.
 */
const SearchErrorState: React.FC<SearchErrorStateProps> = ({ children }) => {
  // `catchError` stops InstantSearch from re-throwing the error as an
  // unhandled promise rejection; we render it instead.
  const { status, refresh } = useInstantSearch({ catchError: true });

  if (status === 'error') {
    return <SearchErrorMessage onRetry={refresh} />;
  }

  // React renders any children, but React 17 types only allow a
  // component to return an element, that is why it is cast.
  return children as React.ReactElement;
};

export default SearchErrorState;
